import React, { useRef, useState, useEffect } from 'react';
import { FloatingLabel, Form, InputGroup } from 'react-bootstrap';
import { useOpenDiagnoisticTopicDetails } from '../../../Queries/QueryHooks/askclir.hook';
import { MalesIcon, FemalesIcon } from '../../askClirnet/icons';
// import LogoFinal from 'https://img-cdn.clirnet.com/askClirImage/logoFinal_Zy86C4Si0.svg';
import ReactHtmlParser from 'react-html-parser';
const DiagnosisHeroCard = ({ id }) => {
  const indexRef = useRef(0);
  const [blinkingText, setBlinkingText] = useState(false);
  const animationRef = useRef(null);
  const [topicText, setTopicText] = useState('');
  const [answertext, setAnswertext] = useState('');
  const idRef = useRef(id);
  const [noDetails, setNoDetails] = useState(false);
  const [promptDetails, setPromptDetails] = useState({
    gender: '',
    age: '',
    chief_complaint: '',
    investigation: '',
    patient_history: '',
    family_history: '',
    medication_history: '',
    innitial_investigation: '',
    diagnosis_count: '4',
    x: 'Dr',
    thread_id: ''
  });
  const animate = (timestamp) => {
    if (indexRef.current < text.length) {
      // setDisplayedText(text.substring(0, indexRef.current + 1));
      indexRef.current += 1;
      animationRef.current = requestAnimationFrame(animate);
    }
  };
  function textIteratorFun(text, partLength) {
    let index = 0;
    return {
      next() {
        if (index >= text.length) {
          return { done: true };
        }
        const part = text.slice(index, index + partLength);
        index += partLength;
        return { value: part, done: false };
      }
    };
  }
  const getTopicDetailsSuccess = (res) => {
    console.log('NOW_SUCCESS', res);

    if (res?.length > 0) {
      console.log('res_success', res[0].detail[0]?.question);
      let parsed = JSON.parse(res[0].detail[0]?.question);
      setPromptDetails(parsed);
    } else {
      idRef.current = 1;
      detailRefetch();
    }
  };
  const getTopicDetailsError = () => {
    console.log('NOW_ERROR');
    idRef.current = 1;
    detailRefetch();
  };

  const {
    data: chatList,
    isLoading,
    refetch: detailRefetch
  } = useOpenDiagnoisticTopicDetails(
    idRef.current,
    getTopicDetailsSuccess,
    getTopicDetailsError,
    true
  );
  useEffect(() => {
    if (!(chatList?.length > 0)) {
      return false;
    }

    const iterator = textIteratorFun(chatList[0]?.topic, 10);
    let result = iterator.next();
    const intervalId = setInterval(() => {
      if (result?.done) {
        clearInterval(intervalId);
        setBlinkingText(false);
      } else {
        if (!blinkingText) {
          setBlinkingText(true);
        }
        setTopicText((prevText) => prevText + result.value);
        result = iterator.next();
      }
    }, 100);

    return () => {
      setTopicText('');
      clearInterval(intervalId);
      setBlinkingText(false);
    };
  }, [chatList]);
  useEffect(() => {
    if (!(chatList?.length > 0) || !(chatList[0]?.detail[0]?.answer)) {
      setNoDetails(true);
      return false;
    }

    const iterator = textIteratorFun(chatList[0]?.detail[0]?.answer, 10);
    let result = iterator.next();
    const intervalId = setInterval(() => {
      if (result?.done) {
        clearInterval(intervalId);
        setBlinkingText(false);
      } else {
        if (!blinkingText) {
          setBlinkingText(true);
        }
        setAnswertext((prevText) => prevText + result.value);
        result = iterator.next();
      }
    }, 100);

    return () => {
      setAnswertext('');
      clearInterval(intervalId);
      setBlinkingText(false);
    };
  }, [chatList]);
  //   console.log('CONSOLE_LOG', promptDetails, chatList);
  return (
    <>
      <div className="col-12 bg-white rounded-4 p-4 shadow disgnosisShare position-relative">
        <div className="d-flex bg-light flex-column flex-column align-items-center justify-content-center justify-content-sm-between flex-sm-row px-4 pt-5 p-sm-20 pb-4 rounded-4">
          <div className="LogoFinal pb-3 pb-sm-0 d-flex flex-column">
            <img
              className="img-fluid"
              src={'https://img-cdn.clirnet.com/askClirImage/logoFinal_Zy86C4Si0.svg'}
            />
            <span className="fs-5 pt-3">AI Powered Doctor's Assistant</span>
          </div>
          <div className="fs-1 magenta-text text-start fw-semibold text-black addButton pe-5 pe-sm-0">
            Differential Diagnosis (DDx)
          </div>
        </div>
        <div className="col-12 border mt-4 p-4 text-start rounded-4 bgMagenta fs-3">
          <p className="fw-semibold text-white">{topicText}</p>
        </div>
        <div className="col-12 text-start position-relative mt-4 fs-3">
          <div className="ms-4 mt-4 bg-light text-black p-4 rounded-4 diagnosisAnswer">
            {ReactHtmlParser(answertext)}
          </div>
        </div>
      </div>
      <div className="col-12 bg-white rounded-4 p-4 mt-4 shadow disgnosisShareForm">
        <FloatingLabel
          className="mb-5"
          controlId="floatingTextarea2"
        // label="Chief Complaints. Ex - My child has a fever and sore throat.*"
        >
          <Form.Control
            type="text"
            as="textarea"
            disabled
            name="chief_complaint"
            className="fs-4 fw-medium text-dark"
            aria-describedby="basic-addon1"
            placeholder="Chief Complaints *"
            value={promptDetails?.chief_complaint}
          />
          <label className="mw-100 line-clamp-1" htmlFor="floatingTextarea2">
            Chief Complaints. Ex - My child has a fever and sore throat.*
          </label>
        </FloatingLabel>
        <div className="d-flex flex-column flex-md-row align-items-start justify-content-start mb-5">
          <div className="w-100 d-flex flex-column flex-sm-row align-items-sm-center align-items-start justify-content-start mb-4 mb-sm-0">
            <p className="p-0 fs-3 fw-semibold pe-5">Gender</p>
            <div className="d-flex flex-row align-items-center justify-content-start">
              <div className="d-flex flex-row border rounded-3 p-3 me-4">
                <Form.Check
                  className="pt-2 me-3"
                  type="radio"
                  aria-label="radio 1"
                  label={`Male`}
                  name={'gender'}
                  checked={promptDetails?.gender === 'Male'}
                  value={'Male'}

                // onChange={getInput}
                />
                <span>
                  <MalesIcon />
                </span>
              </div>
              <div className="d-flex flex-row border rounded-3 p-3">
                <Form.Check
                  className="pt-2 me-3"
                  type="radio"
                  aria-label="radio 2"
                  label={`Female`}
                  name={'gender'}
                  checked={promptDetails?.gender === 'Female'}
                  value={'Female'}
                // onChange={getInput}
                />
                <span>
                  <FemalesIcon />
                </span>
              </div>
            </div>
          </div>
          <div className="w-100 d-flex flex-column flex-sm-row ms-0 ms-md-0 align-items-start align-items-sm-center">
            <p className="p-0 fs-3 fw-semibold pe-5">Age</p>
            <Form.Control
              className="align-item-stretch inputHeight fs-4"
              type="text"
              id="Age"
              disabled
              name="age"
              // onChange={getInput}
              value={promptDetails?.age}
              aria-describedby="age"
            />
          </div>
        </div>
        <div className="d-flex flex-column align-items-start justify-content-start mb-5">
          <p className="text-start mb-0">Add More Details</p>
          <div className="addButton text-start d-flex flex-column flex-md-row align-items-center justify-content-start gap-4 gap-sm-3 gap-md-20 gap-lg-5">
            <a
              className={`btn btn-light text-black fs-4 rounded-4 d-inline-block cursorPointer p-3 p-md-4`}
            >
              Patient/Family History
            </a>
            <a
              className={`btn btn-light text-black fs-4 rounded-4 d-inline-block cursorPointer p-3 p-md-4`}
            >
              Drug/Medication History
            </a>
            <a
              className={`btn btn-light text-black fs-4 rounded-4 d-inline-block cursorPointer p-3 p-md-4`}
            >
              Physical Examination
            </a>
          </div>
        </div>
        <div className="mt-5 d-flex flex-column flex-sm-row w-100">
          <div className="d-flex flex-row align-items-center align-items-sm-center mb-4 mb-sm-0 flex-grow-1">
            <div className="p-0 fs-4 pe-5 text-start">
              How many DDx's would you like to receive?
            </div>
            <Form.Select
              size="sm"
              className="fs-3 inputHeight inputWidth px-3 diagnosisSelect lh-1"
              name="diagnosis_count"
              disabled
            // onChange={getInput}
            // value={promptDetails?.diagnosis_count ?? ''}
            >
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
            </Form.Select>
          </div>
          {/* <a className="shadow ms-sm-auto ms-0 px-5 py-4 mt-3 mt-sm-0 rounded-4 text-white fs-3 fw-semibold startBtn cursorPointer d-flex align-items-center justify-content-center">
             Request Differential Diagnosis 
          </a> */}
        </div>
      </div>
    </>
  );
};

export default DiagnosisHeroCard;
